module.exports = __webpack_public_path__ + "static/media/works1.d88a9733.png";